import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import selectBase from './selectBase'

const selectBillingUsage = createBasicSelector(
  selectBase,
  base => base.usage || emptyObj
)

export default selectBillingUsage
